import React from "react";
export default function Save() {
  return (
    <div className="save">
      <h4 className="primary-heading text-white">
        Save Big With our Cheap Swift Rental!
      </h4>
      <p className="text text-white">
        Top Airports. Local Suppliers. <span>24/7 </span> Support.
      </p>
    </div>
  );
}
